import { get, Request, Response } from '@/api'
import { PageableResponse } from '@/types'
import { ImpersonationStatus, Subsidiary } from '@/types/index'

export default {
  subsidiariesSearch: (
    page: number,
    size: number,
    keyword?: string
  ): Promise<Response<PageableResponse<Subsidiary>>> => {
    const config: Request = {
      params: {
        page: page,
        size: size,
        keyword: keyword
      }
    }
    return get<PageableResponse<Subsidiary>>('/subsidiaries/search', config)
  },
  impersonationStatus: (): Promise<Response<ImpersonationStatus>> => {
    return get<ImpersonationStatus>('/subsidiaries/impersonation-status')
  },
  switchToSubsidiary: (subsidiaryId: string): Promise<Response<string>> => {
    return get<string>(`/subsidiaries/${subsidiaryId}/token`)
  }
}
